import styled from 'styled-components';

import { Popup } from 'components/uikit/Popup/Popup';
import { Button } from 'components/uikit/Button/Button';

export const StyledPopup = styled(Popup)`
  min-width: 620px;
  max-width: 620px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.h2`
  margin-bottom: 12px;

  font: var(--font-heading-large-28);
`;

export const Description = styled.p`
  margin-bottom: 0px;
`;

export const DescriptionText = styled.p`
  margin-bottom: 0px;

  font: var(--font-regular-15);
`;

export const SendButton = styled(Button).attrs({ size: 'm' })`
  width: 100%;
  margin-top: 60px;
`;

export const TryOutButton = styled(SendButton)``;

export const TimeOutButton = styled(SendButton)``;
